/**
 * Helper for marking an element busy with class while a promise is pending
 * @module lib/busyButton
 */

const CLASS_BUSY = 'is-busy';

/**
 * Mark given el busy with the `is-busy` class with given promise is pending
 * @param {HTMLElement} el
 * @param {Promise} promise
 */
export function withBusyButtonWhile(el, promise) {
  if (!el) return promise;
  el.disabled = true;
  el.classList.add(CLASS_BUSY);

  return promise.finally(() => {
    el.disabled = false;
    el.classList.remove(CLASS_BUSY);
  });
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/busyButton.js